import '../css/index.scss'
import $ from 'jquery'
import anime from 'animejs'
import _ from 'lodash'
import { gsap } from "gsap"
import ScrollTrigger from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

'use strict';

// window
var winW = window.innerWidth;
var winH = window.innerHeight;
var BREAKPOINT_SP = 768;
var deviceType;
var ajust;

// canvas
var canvasWidth;
var canvasHeight;
var canvasFrame01;
var canvasFrame02;
var canvasFrame03;
var sceneSwitch01;
var sceneSwitch02;
var sceneSwitch03;
var sceneSwitch04;
var canvasRate;
var canvasDuration;

// other
var scrollTopValue;
var saveScrollTopValue;
var smpflug = 0;
var currentNavi;


$(function(){

    // loading
    var LOADING_SELECTOR = '.rfwt__loading';
    var CONTENT_LOAD_COMPLETEED_REMOVE_CLASS = 'loading';
    var CONTENT_LOAD_COMPLETEED = 'complete';
    var CONTENT_SELECTOR = '.fashion-week';

    // UA
    const ua = navigator.userAgent.toLowerCase();
    if ( ua.indexOf("ipad") > -1 || (ua.indexOf("macintosh") > -1 && "ontouchend" in document) ) {
        smpflug = 1;
    }

    var loading = function() {
        $( CONTENT_SELECTOR ).addClass( CONTENT_LOAD_COMPLETEED_REMOVE_CLASS );

        // アクセス時にハッシュがあったとき
        $('#header').addClass('is-landing').dequeue();
        const urlHash = location.hash;
        if(urlHash) {
            $('body,html').stop().scrollTop(0);
            setTimeout(function(){
                const targetHash = $(urlHash);
                const positionY = targetHash.offset().top;
                const delaytime = 800;
                $('html,body').animate({scrollTop:positionY}, 0);
                $('#header').delay(delaytime).queue(function() {
                    $(this).removeClass('header--unpinned').dequeue();
                    $(this).removeClass('is-landing').dequeue();
                    $('html,body').addClass('is-scroll');
                });
            });
        }

        setTimeout(function(){
            $( LOADING_SELECTOR )
                .css( 'opacity', 0 )
                .on( 'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(){
                    $( LOADING_SELECTOR ).remove();
                    $( CONTENT_SELECTOR ).removeClass( CONTENT_LOAD_COMPLETEED_REMOVE_CLASS );
                    $( CONTENT_SELECTOR ).addClass( CONTENT_LOAD_COMPLETEED );

                    if(!urlHash) {
                        if (smpflug || winW < BREAKPOINT_SP ) {

                            // SMP

                        } else {

                            
                            $('body,html').stop().scrollTop(0);

                            const targetHash = $('#about');
                            const positionY = targetHash.offset().top;
                            const delayTime = 800;
                            // PC
                            
                            $('html,body').stop().animate({scrollTop:positionY}, 600);
                            setTimeout(function(){
                                $( CONTENT_SELECTOR ).delay(delayTime).queue(function() {
                                    $('#header').removeClass('header--unpinned');
                                    $('html,body').addClass('is-scroll');
                                    $('#guide-Scroll').addClass('is-show');
                                });
                            });

                        }
                    }

                    if (smpflug || winW < BREAKPOINT_SP ) {

                        const videoLayer = document.getElementById('youtube-area')
                              videoLayer.classList.add('is-show');
                        const delayTime = 800;
                        // SMP
                        $( CONTENT_SELECTOR ).delay(delayTime).queue(function() {
                            $('#s-about').addClass('is-animated').dequeue();
                            $('#guide-Scroll').addClass('is-show');
                        });

                    } else {

                        // PC
                        const canvasLayer = document.getElementById('canvas')
                              canvasLayer.classList.add('is-show');
                              
                        const delayTime = 0;
                        $( CONTENT_SELECTOR ).delay(delayTime).queue(function() {
                            //gsap.to(window, { duration: 2.4, scrollTo: '#about' });
                        });
                        $('html,body').addClass('is-scroll');
                        $('#guide-Scroll').addClass('is-show');
                    }
            });
        }, 1600);
    }

    $(window).on('load', loading);
    init();

    if ( smpflug || winW < BREAKPOINT_SP ) {
        $('#s-about, #s-key-visual, #s-theme, #digital-voice .c-chapter-header, #footer').css({ height: winH });
        $('#youtube-area').css({ height: winH*1.05 });
    }

    function init() {
        winH = window.innerHeight;
        winW = window.innerWidth;
        setHeight();

        if (smpflug || winW < BREAKPOINT_SP ) {

            // SMP
            deviceType = 'small';
            canvasWidth = 828;
            canvasHeight = 1472;
            canvasFrame01 = 117;
            canvasFrame02 = 34;
            canvasFrame03 = 45;
            canvasDuration = 0;
            canvasRate = .3;
            ajust = .5;

            sceneSwitch01 = $('#generative-ai').offset().top + winH * 1.5;

        } else {

            // PC
            deviceType = 'large';
            canvasWidth = 1920;
            canvasHeight = 1080;
            canvasFrame01 = 117;
            canvasFrame02 = 34;
            canvasFrame03 = 45;
            canvasDuration = 100;
            canvasRate = .15;
            ajust = 0;

            sceneSwitch01 = $('#blank-04').offset().top;
            sceneSwitch02 = $('#blank-05').offset().top + winH * 1.5;
            sceneSwitch03 = $('#party').offset().top + winH * 2;
            sceneSwitch04 = $('#event').offset().top + winH * 2;

            $('.js-setHeight').each(function(){
                $(this).css({ height: winH });
            });

        }
    }

    function setHeight() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    // GSAP
    let matchMedia = gsap.matchMedia();
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(ScrollToPlugin);

    matchMedia.add("(min-width: 800px)", () => { // PC

        if(smpflug) {
        } else {

            // anchor link
            gsap.utils.toArray('a[href^="#"]').forEach(function(a) {
                a.addEventListener("click", function(e) {
                    const scrollTarget = e.target.getAttribute('href');

                    if(scrollTarget == '#generative-ai') {

                        $('.js-side-scroll-01, .js-side-scroll-body-01')
                            .css({transform:'translate(0, 0)'});

                    } else if(scrollTarget == '#exhibition') {

                        $('.js-side-scroll-02, .js-side-scroll-body-02')
                            .css({transform:'translate(0, 0)'});

                    } else if(scrollTarget == '#party') {

                        $('.js-side-scroll-03, .js-side-scroll-body-03')
                            .css({transform:'translate(0, 0)'});

                    } else {
                        // e.preventDefault();
                        // gsap.to( window, {
                        //     duration: .5,
                        //     ease: 'power4.out',
                        //     scrollTo: {
                        //         y: e.target.getAttribute('href'),
                        //         autoKill: false,
                        //     }
                        // });
                    }
                    return false;
                });
            });


            // Scroll Animetion

            const about_anime = gsap.timeline({
                defaults: { opacity: 1 },
                toggleActions: 'play complete reverse reset',
                scrollTrigger: {
                    trigger: ".js-scroll-animation-trigger-1",
                    start: "top top",
                    endTrigger: ".js-scroll-animation-trigger-2",
                    end: '+=' + winH,
                    scrub: true,
                    // markers: true,
                    pin: true,
                    pinSpacing: false,
                    anticipatePin: 1,
                    invalidateOnRefresh: true
                }
            });

            about_anime.set('.js-scroll-animation-element-1', { opacity: 1 });
            about_anime.to('.js-scroll-animation-element-1',
                { keyframes: [
                    { duration: 8, opacity: 1 },
                    { duration: .5, opacity: 0 },
                ]}, '<',
            );

            const intro01_anime = gsap.timeline({
                defaults: { opacity: 0 },
                toggleActions: 'play complete reverse reset',
                scrollTrigger: {
                    trigger: ".js-scroll-animation-trigger-2",
                    start: "top top",
                    endTrigger: ".js-scroll-animation-trigger-3",
                    end: '+=' + winH,
                    scrub: true,
                    // markers: true,
                    pin: true,
                    pinSpacing: false,
                    anticipatePin: 1,
                    invalidateOnRefresh: true
                }
            });

            intro01_anime.set('.js-scroll-animation-element-2 .title', { opacity: 0, transform: "matrix(1, 0, 0, 1, 0, 0)" });
            intro01_anime.set('.js-scroll-animation-element-2 .btn-modal-open-wrapper', { opacity: 0 });
            intro01_anime.to('.js-scroll-animation-element-2 .title',
                { keyframes: [
                    { duration: 4, opacity: 1 },
                    { duration: 16, opacity: 1 },
                    { duration: 8, transform:"matrix(1.25, 0, 0, 1.25, 0, 0)", opacity: 0 },
                ]}, '<',
            );
            intro01_anime.to('.js-scroll-animation-element-2 .btn-modal-open-wrapper',
                { keyframes: [
                    { duration: 4, opacity: 1 },
                    { duration: 16, opacity: 1 },
                    { duration: 4, opacity: 0 },
                ]}, '<',
            );

            const intro02_anime = gsap.timeline({
                defaults: { opacity: 0 },
                toggleActions: 'play complete reverse reset',
                scrollTrigger: {
                    trigger: ".js-scroll-animation-trigger-3",
                    start: "top top",
                    endTrigger: "#s-theme",
                    end: '+=' + winH,
                    scrub: true,
                    // markers: true,
                    pin: true,
                    pinSpacing: false,
                    anticipatePin: 1,
                    invalidateOnRefresh: true
                }
            });

            intro02_anime.set('.js-scroll-animation-element-3', { opacity: 0 });
            intro02_anime.to('.js-scroll-animation-element-3',
                { keyframes: [
                    { duration: 4, opacity: 1 },
                    { duration: 16, opacity: 1 },
                    { duration: 4, opacity: 0 },
                ]}, '<',
            );


            // Side scroll area

            const listWrapperEl = []
            const listEl = []
            const listTrigger = []

            for (let i = 1; i <= 3; i++) {

                listWrapperEl[i] = document.querySelector('.side-scroll-wrapper-0' + i )
                listEl[i] = document.querySelector('.side-scroll-body-0' + i)
                listTrigger[i] = '.js-side-scroll-0' + i

                gsap.to(listEl[i], {
                    x: () => -(listEl[i].clientWidth - listWrapperEl[i].clientWidth),
                    ease: 'none',
                    scrollTrigger: {
                        trigger: listTrigger[i],
                        start: 'top top',
                        end: () => `+=${listEl[i].clientWidth - listWrapperEl[i].clientWidth}`,
                        scrub: true,
                        // markers: true,
                        pin: true,
                        anticipatePin: 1,
                        invalidateOnRefresh: true,
                    },
                });

            }


            // scene-01
            const canvas01 = document.getElementById('scene-01');
            const context01 = canvas01.getContext('2d');
            canvas01.width = canvasWidth;
            canvas01.height = canvasHeight;

            const images01 = []
            const scene01 = { frame: 0 };

            const frameCount01 = canvasFrame01;
            const currentFrame01 = index => (
            `images/scene01/${(deviceType)}/${(index + 1).toString().padStart(4, '0')}.jpg`
            );

            for (let i = 0; i < frameCount01; i++) {
                const img = new Image();
                img.src = currentFrame01(i);
                images01.push(img);
            }

            gsap.set(
                scene01,
                {
                    opacity: 0,
                    duration: canvasDuration
                }
            );
            gsap.fromTo(
                scene01,
                {
                    frame: 0
                },
                {
                    frame: frameCount01 - 1,
                    snap: "frame",
                    scrollTrigger: {
                        // markers: true,
                        trigger: '.scene01-wrapper',
                        start: 'top top',
                        endTrigger: '#generative-ai',
                        end: 'top top',
                        scrub: canvasRate,
                        onUpdate: renderImage01
                    }
                }
            );

            images01[0].onload = renderImage01;
            function renderImage01() {
                const image = images01[scene01.frame];
                if (!image) return;
                // if ( winW < BREAKPOINT_SP && scene01.frame % 2 == 0 ) return;

                // context01.clearRect( 0, 0, canvas01.width, canvas01.height );
                context01.drawImage( image, 0, 0, canvas01.width, canvas01.height );
            }

            // scene-02
            const canvas02 = document.getElementById('scene-02');
            const context02 = canvas02.getContext('2d');
            canvas02.width = canvasWidth;
            canvas02.height = canvasHeight;

            const images02 = []
            const scene02 = { frame: 0 };

            const frameCount02 = canvasFrame02;
            const currentFrame02 = index => (
            `images/scene02/${(deviceType)}/${(index + 1).toString().padStart(4, '0')}.jpg`
            );

            for (let i = 0; i < frameCount02; i++) {
                const img = new Image();
                img.src = currentFrame02(i);
                images02.push(img);
            }

            gsap.set(
                scene02,
                {
                    opacity: 0,
                    duration: canvasDuration
                }
            );
            gsap.fromTo(
                scene02,
                {
                    frame: 0
                },
                {
                    frame: frameCount02 - 1,
                    snap: "frame",
                    scrollTrigger: {
                        // markers: true,
                        trigger: '#blank-04',
                        start: 'top top',
                        endTrigger: '#exhibition',
                        end: 'top top',
                        scrub: canvasRate,
                        onUpdate: renderImage02
                    }
                }
            );

            images02[0].onload = renderImage02;
            function renderImage02() {
                const image = images02[scene02.frame];
                if (!image) return;
                // if ( winW < BREAKPOINT_SP && scene02.frame % 2 == 0 ) return;

                // context02.clearRect( 0, 0, canvas02.width, canvas02.height );
                context02.drawImage( image, 0, 0, canvas02.width, canvas02.height );
            }

            // scene-03
            const canvas03 = document.getElementById('scene-03');
            const context03 = canvas03.getContext('2d');
            canvas03.width = canvasWidth;
            canvas03.height = canvasHeight;

            const images03 = []
            const scene03 = { frame: 0 };

            const frameCount03 = canvasFrame03;
            const currentFrame03 = index => (
            `images/scene03/${(deviceType)}/${(index + 1).toString().padStart(4, '0')}.jpg`
            );

            for (let i = 0; i < frameCount03; i++) {
                const img = new Image();
                img.src = currentFrame03(i);
                images03.push(img);
            }

            gsap.set(
                scene03,
                {
                    opacity: 0,
                    duration: canvasDuration
                }
            );
            gsap.fromTo(
                scene03,
                {
                    frame: 0
                },
                {
                    frame: frameCount03 - 1,
                    snap: "frame",
                    scrollTrigger: {
                        //markers: false,
                        trigger: '#blank-05',
                        start: 'top top',
                        endTrigger: '#party',
                        end: 'top top',
                        scrub: canvasRate,
                        onUpdate: renderImage03
                    }
                }
            );

            images03[0].onload = renderImage03;
            function renderImage03() {
                const image = images03[scene03.frame];
                if (!image) return;
                // if ( winW < BREAKPOINT_SP && scene03.frame % 2 == 0 ) return;

                // context03.clearRect( 0, 0, canvas03.width, canvas03.height );
                context03.drawImage( image, 0, 0, canvas03.width, canvas03.height );
            }
        }
    });
    matchMedia.add("(max-width: 799px)", () => { // SMP
    });

    // resize
    var resizeTimer;
    var savedeviceType;
    var interval = Math.floor(1000 / 60 * 10);

    window.addEventListener('resize', function() {

        if (!smpflug || winW > BREAKPOINT_SP ) {
            $('#canvas .canvas__item').each(function(){
                $(this).css({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            });
        }

        savedeviceType = deviceType;
        if (resizeTimer !== false) {
            clearTimeout(resizeTimer);
        }
        resizeTimer = setTimeout(function() {
            init();
            if(savedeviceType !== deviceType) {
                window.location.reload();
            }
            ScrollTrigger.refresh();
        }, interval);
    });


    // sceneSwitch
    $(window).on('scroll', function() {

        scrollTopValue = $(this).scrollTop();
        const gHeader = $('#header');
        const canvasArea = $('#canvas');
        const videoArea = $('#youtube-area');

        // header display
        if(gHeader.hasClass('is-landing')) {
            gHeader.addClass('header--unpinned');
            gHeader.removeClass('is-landing');
        }

        if ( deviceType == 'small' ) {

            // Youtube display
            if( scrollTopValue > sceneSwitch01 ){
                videoArea.removeClass('is-show');
            } else {
                videoArea.addClass('is-show');
            }

        } else {

            // canvas display
            if( scrollTopValue > sceneSwitch04 ){
                canvasArea.removeClass('is-show');
            } else {
                canvasArea.addClass('is-show');
            }

            if( scrollTopValue < sceneSwitch01 ){
                $('#canvas #scene-01').addClass('is-show');
                $('#canvas #scene-02').removeClass('is-show');
                $('#canvas #scene-03').removeClass('is-show');
            }else if( scrollTopValue < sceneSwitch02 ) {
                $('#canvas #scene-01').removeClass('is-show');
                $('#canvas #scene-02').addClass('is-show');
                $('#canvas #scene-03').removeClass('is-show');
            }else if( scrollTopValue < sceneSwitch03 + winH ) {
                $('#canvas #scene-01').removeClass('is-show');
                $('#canvas #scene-02').removeClass('is-show');
                $('#canvas #scene-03').addClass('is-show');
            }

            // global navi

            if( scrollTopValue >= $('#s-about').offset().top && scrollTopValue < $('#s-key-visual').offset().top - winH * .25 ){
                $(".l-header-nav ul li").removeClass('is-current');
                $('#navItem1').addClass('is-current');
                currentNavi = 1;
            }else if( scrollTopValue >= $('#s-key-visual').offset().top - winH * .25 && scrollTopValue < $('#generative-ai').offset().top - winH * .15 ){
                $(".l-header-nav ul li").removeClass('is-current');
                $('#navItem2').addClass('is-current');
                currentNavi = 2;
            }else if( scrollTopValue >= $('#generative-ai').offset().top - winH * .15 && scrollTopValue < $('#exhibition').offset().top - winH * .15 ) {
                $(".l-header-nav ul li").removeClass('is-current');
                $('#navItem3').addClass('is-current');
                currentNavi = 3;
            }else if( scrollTopValue >= $('#exhibition').offset().top - winH * .15 && scrollTopValue < $('#party').offset().top - winH * .15) {
                $(".l-header-nav ul li").removeClass('is-current');
                $('#navItem4').addClass('is-current');
                currentNavi = 4;
            }else if( scrollTopValue >= $('#party').offset().top - winH * .15 && scrollTopValue < $('#digital-voice').offset().top - winH * .15 ) {
                $(".l-header-nav ul li").removeClass('is-current');
                $('#navItem5').addClass('is-current');
                currentNavi = 5;
            }else if( scrollTopValue >= $('#digital-voice').offset().top - winH * .15 && scrollTopValue < $('#credit').offset().top - winH * .15 ) {
                $(".l-header-nav ul li").removeClass('is-current');
                $('#navItem6').addClass('is-current');
                currentNavi = 6;
            }else {
                $(".l-header-nav ul li").removeClass('is-current');
            }

        }
    });

    // Modal
    var modal = $('.modal');
    $('.js-modal-open').each(function(){
        $(this).on('click',function(){
            $( '.modal-container_inner' ).scrollLeft(0);
            showDialog();
            saveScrollTopValue = scrollTopValue;
            $('html, body').addClass('modal-open').stop().animate({ scrollTop: saveScrollTopValue }, 0);
            const target = $(this).data('target');
            const modalTarget = '#' + target;
            modal.addClass('show');
            $( modalTarget ).addClass('show');
            $('#header').addClass('header--unpinned');
        });
    });

    $('.js-modal-close, #header .l-header-nav a, #drawer-nav .nav-item-link').on('click',function(){
        const parent = document.querySelector('#modal-content').parentElement;
        const modalTarget = '#' + parent.id;
        closeDialog();
        modal.removeClass('show');
        $( '.modal-container' ).removeClass('show');
        $('html, body').removeClass('modal-open').stop().animate({ scrollTop: saveScrollTopValue }, 0);
        $( '.trigger-area' ).each(function() {
            $(this).css('left','unset');
        });
        $('#header').removeClass('header--unpinned');
    });

    const showDialog = () => {
        document.getElementById('modals').classList.add('show')
        const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
        const body = document.body;
        body.style.position = 'fixed';
        body.style.top = `-${scrollY}`;
    };

    const closeDialog = () => {
        const body = document.body;
        const scrollY = body.style.top;
        body.style.position = '';
        body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
        document.getElementById('modals').classList.remove('show');
    }

    window.addEventListener('scroll', () => {
        document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    });

    // scroll-content-x
    const scrollElements = document.querySelectorAll('.scroll-content-x');
    scrollElements.forEach(function(scrollElement) {
        scrollElement.addEventListener('wheel', (e) => {

            if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;

            const maxScrollLeft = scrollElement.scrollWidth - scrollElement.clientWidth;

            if (
                (scrollElement.scrollLeft <= 0 && e.deltaY < 0) ||
                (scrollElement.scrollLeft >= maxScrollLeft && e.deltaY > 0)
            )
                return;

            e.preventDefault();
            scrollElement.scrollLeft += e.deltaY;
        });
    });

    if(deviceType !== 'small') {

        // progress-bar
        $('#modal-about').on('scroll resize load', function () {
            const windowWidth = window.innerWidth;
            const ModalWidth = $('.modal-about .c-modal-header').innerWidth() + $('.modal-about .c-modal-body').innerWidth();
            const mordalTarget = document.getElementById('modal-about');
            const x = mordalTarget.scrollLeft;

            const scrollPos = ModalWidth - windowWidth;
            const progressInt = (x / scrollPos) * 100 + .05;
            const progressBar = document.getElementById('js-progress-bar-01');

            if ( scrollPos > x ) {
                progressBar.setAttribute("value", progressInt);
            } else {
                progressBar.setAttribute("value", 100);
            }
        });

        $('#modal-key-visual').on('scroll resize load', function () {
            const windowWidth = window.innerWidth;
            const ModalWidth = $('.modal-key-visual .c-modal-header').innerWidth() + $('.modal-key-visual .c-modal-body').innerWidth();
            const mordalTarget = document.getElementById('modal-key-visual');
            const x = mordalTarget.scrollLeft;

            const scrollPos = ModalWidth - windowWidth;
            const progressInt = (x / scrollPos) * 100 + .05;
            const progressBar = document.getElementById('js-progress-bar-02');

            if ( scrollPos > x ) {
                progressBar.setAttribute("value", progressInt);
            } else {
                progressBar.setAttribute("value", 100);
            }
        });

    }

    // scroll guide
    var scrollguide = function() {
        const guide = $('#guide-Scroll');
        var guideEndPC = $('#digital-voice');
        var guideEndSP = $('#generative-ai');
        var guideEndOffset = null;
        if(deviceType !== 'large') {
            guideEndOffset = guideEndSP.offset().top;
        } else {
            guideEndOffset = guideEndPC.offset().top;
        }
        if ($(this).scrollTop() > (guideEndOffset - winH)) {
            guide.fadeOut();
        } else {
            guide.fadeIn();
        }
    };
    $(window).on('scroll', scrollguide);


    // accordion (Profile)
    window.onload = accordionInit();
    function accordionInit() {
        const accordions = document.querySelectorAll('.js-accordion');
        const accordionsArr = Array.prototype.slice.call(accordions);

        accordionsArr.forEach((accordion) => {
            const accordionTriggers = accordion.querySelectorAll('.js-accordion-trigger');
            const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);

            accordionTriggersArr.forEach((trigger) => {
                trigger.addEventListener('click', () => {
                trigger.classList.toggle('is-active');
                const accordionContent = trigger.querySelector('.accordion__content');
                if (trigger.classList.contains('is-active')) {
                    accordionContent.style.height = 
                    accordionContent.children[0].clientHeight + "px";
                } else {
                    accordionContent.style.height = 0;
                }
                });
            });
        });
    }

    $('.accordion_01 .accordion_header').on('click', function(){
        $(this).next('.accordion_inner').slideToggle('slow');
        $(this).toggleClass('is-active');
    });

});


// js-animate

let targets = document.querySelectorAll('.js-animate');

window.addEventListener('scroll', function () {
    var scroll = window.scrollY;
    var windowAjust = window.innerHeight * ajust;

    for (let target of targets) {
        var targetPos = target.getBoundingClientRect().top + scroll - 1;
        if (scroll >= targetPos - windowAjust ) {
            target.classList.add('is-animated');
        } else {
            target.classList.remove('is-animated');
        }
    }
});


// global header

const gHeader = document.getElementById('header');
const hH = gHeader.clientHeight;
const secAbout = document.getElementById('about');
const secAboutPos = secAbout.offsetTop;

let Pos = 0;
let savePos = 0;

const onScroll = () => {
    if( deviceType == 'small') {
        // SMP
        if (Pos > hH && Pos > savePos) {
            gHeader.classList.remove('header--pinned');
            gHeader.classList.add('header--unpinned');
        }
        if (Pos < hH || Pos < savePos ) {
            gHeader.classList.remove('header--unpinned');
            gHeader.classList.add('header--pinned');
        }
    } else {
        if($('#header').hasClass('is-landing')){
            return;
        } else {
            if (Pos > secAboutPos && Pos > savePos) {
                gHeader.classList.remove('header--pinned');
                gHeader.classList.add('header--unpinned');
            }
            if (Pos < secAboutPos || Pos < savePos ) {
                gHeader.classList.remove('header--unpinned');
                gHeader.classList.add('header--pinned');
            }
        }
    }
    savePos = Pos;
};

window.addEventListener('scroll', () => {
    Pos = window.scrollY;
    if( Pos > secAboutPos ) {
        onScroll();
    }
});


// Side Menu

class SideMenu {
    constructor(id) {
        this.id = id
        this.isShown = false
        this.element = document.getElementById(id)
        this.element.style.opacity = 0.0

        _.forEach(this.element.querySelectorAll('.nav-item-link'), n => n.addEventListener('click', () => {
            sideMenuButton.hide()
        }))
    }

    show(complete, isForce = false) {
        if (isForce || !this.isShown) {
            this.isShown = true
            anime({
                targets: this.element,
                opacity: 1.0,
                duration: 250,
                easing: 'linear',
                complete
            })
        }
    }

    hide(complete, isForce = false) {
        if (isForce || this.isShown) {
            this.isShown = false
            anime({
                targets: this.element,
                opacity: 0.0,
                duration: 250,
                easing: 'linear',
                complete
            })
        }
    }
}

class SideMenuButton {
    constructor(id) {
        this.id = id
        this.element = document.getElementById(id)
        this.isShownSideMenu = false

        this.element.onclick = e => {
            if (this.using) return
            this.isShownSideMenu ? this.hide() : this.show()
        }
    }

    show() {
        this.using = true
        sideMenu.show(() => this.using = false)
        document.querySelector('body').classList.add('is-open')
        this.isShownSideMenu = true
    }

    hide() {
        sideMenu.hide(() => this.using = false)
        document.querySelector('body').classList.remove('is-open')
        this.isShownSideMenu = false
    }
}

const sideMenu = new SideMenu('drawer-nav');
const sideMenuButton = new SideMenuButton('button-toggle');